import { SectionHeading } from "@/components/SectionHeading";
import { Reveal } from "@/components/Reveal";

const STEPS = [
  { n: "01", title: "LEARN THE PROCESS", desc: "Learn the Position • Event • Entry framework." },
  { n: "02", title: "USE THE OS", desc: "Use P.E.E. OS to organize your execution information." },
  { n: "03", title: "EXECUTE THE PROCESS", desc: "Follow your predefined trade plan." },
  { n: "04", title: "REVIEW THE DATA", desc: "Study your execution through analytics and review." },
  { n: "05", title: "BECOME THE EXECUTOR", desc: "Develop consistency through repetition and accountability." },
];

export default function HowItWorks() {
  return (
    <section id="how-it-works" data-testid="how-it-works-section" className="py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHeading
          chapter="09 — The Path"
          testid="how-it-works-heading"
          title={
            <>
              The <span className="glow-text-neon text-neon">Executor</span> path.
            </>
          }
        />

        <div className="mt-14">
          {STEPS.map((s, i) => (
            <Reveal key={s.n} delay={0.06 * i}>
              <div
                data-testid={`path-step-${i}`}
                className="group grid grid-cols-[auto_1fr] items-baseline gap-6 border-t border-line py-8 transition-colors duration-500 last:border-b hover:bg-charcoal/40 sm:grid-cols-[100px_1fr_1.2fr] sm:gap-10 sm:px-6"
              >
                <span className="font-mono text-sm tracking-[0.2em] text-neon">{s.n}</span>
                <h3 className="font-display text-xl font-extrabold uppercase tracking-tight text-white sm:text-2xl">
                  {s.title}
                </h3>
                <p className="col-span-2 text-sm leading-relaxed text-mist sm:col-span-1">
                  {s.desc}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
